var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"toolbar"},[_c('b-button',{attrs:{"variant":"default","to":{ name: 'construction-task-new' }}},[_vm._v("\n      新規登録\n    ")])],1),_c('div',{staticClass:"main"},[_c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"outlined":""},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var id = ref.item.id;
var value = ref.value;
return [_c('b-link',{attrs:{"to":{
            name: 'construction-task-edit',
            params: { id: id }
          }}},[_vm._v("\n          "+_vm._s(value)+"\n        ")])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }